import { ButtonStyle, ControlSize, FetchStatus, PageMode, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { IPageLink } from "../../../../base/models";
import { IPaymentButtonProps } from "../IPaymentButtonProps";
import { useAuth } from "../../../../../modules/auth";

export const NTTProperties = [
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.OrderNo, name: 'Order No.', type: PropertyType.String },
    { id: Property.EnrolmentNo, name: 'Enrolment No.', type: PropertyType.String },
    { id: Property.Amount, name: 'Amount', type: PropertyType.Number },
    { id: Property.Currency, name: 'Currency', type: PropertyType.String },
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
    { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
    { id: Property.SuccessPage, name: 'Success Page', type: PropertyType.PageLink },
    { id: Property.FailedPage, name: 'Failed Page', type: PropertyType.PageLink },
    { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
    { id: Property.EntityId, name: 'EntityId', type: PropertyType.String },
]

export const useNTTProperties = (props: IAsyncBoundProperties) => {
    const { user } = useAuth()
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IPaymentButtonProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.Label })

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings || !user)
            return;

        const label = bindings.getValue<string>(Property.Label)
        const tooltip = bindings.getValue<string>(Property.Tooltip);
        const icon = bindings.getValue<string>(Property.MaterialIcon)
        const disabled = bindings.getValue<boolean>(Property.Disabled)
        const style = bindings.getValue<ButtonStyle>(Property.BackgroundStyle)
        const size = bindings.getValue<ControlSize>(Property.Size)

        const enrolmentNo = bindings.getValue<string>(Property.EnrolmentNo) || user.userName
        const orderNo = bindings.getValue<string>(Property.OrderNo)
        const amount = bindings.getValue<number>(Property.Amount) || 0
        const currency = bindings.getValue<string>(Property.Currency) || 'INR'
        const successPage = bindings.getValue<IPageLink>(Property.SuccessPage) || { pageMode: PageMode.View }
        const failedPage = bindings.getValue<IPageLink>(Property.FailedPage) || { pageMode: PageMode.View }
        const entity = bindings.getValue<string>(Property.Entity)
        const entityId = bindings.getValue<string>(Property.EntityId)
        const phoneNumber = user.phoneNumber
        const firstName = user.firstName || user.userName

        setProperties({
            label,
            tooltip,
            icon,
            disabled,
            style,
            size,
            enrolmentNo,
            orderNo,
            amount,
            currency,
            successPage,
            failedPage,
            entity,
            entityId,
            phoneNumber,
            firstName
        })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
